export const text = {
  Keys: "Key",
  Desktop: "Desktop",
  Application: "Applicatie",
  Employees: "Medewerkers",
  "My Team": "Mijn team",
  "My Opinion": "Mijn mening",
  "My Development": "Mijn ontwikkeling",
  Onboarding: "Onboarding",
  Academy: "Academy",
  Box: "Box",
  News: "Nieuws",
  Agenda: "Agenda",
  "Admin Overview": "Admin overzicht",
  Modules: "Modules",
  Settings: "Instellingen",
  HR: "HR",
  "Leave Settings": "Verlofinstellingen",
};
